import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {CommonStrings} from '../../../model/CommonStrings';

@Component({
    selector: 'finalize-request-view',
    templateUrl: './finalize-request-view.component.html',
    styleUrls: ['./finalize-request-view.component.scss'],
    standalone: false
})
export class FinalizeRequestViewComponent implements OnInit {

  @Output()
  decision = new EventEmitter<string>();
  isStaffUI = false;

  constructor(@Inject('env') private environment) {
  }

  ngOnInit() {
    this.isStaffUI = this.environment.config.interfaceType === 'STAFF';
  }

  onConfirmChanges() {
    this.decision.emit(CommonStrings.CONFIRM);
  }

  onCancelChanges() {
    this.decision.emit(CommonStrings.CANCEL);
  }
}
